"use strict";
/** Κοινό λεξιλόγιο προγράμματος επιβράβευσης (referral) — web & mobile. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERRAL_COPY = void 0;
exports.REFERRAL_COPY = {
    programTitle: 'Πρόγραμμα επιβράβευσης',
    programLoading: 'Φόρτωση προγράμματος επιβράβευσης…',
    programLoadError: 'Δεν φορτώθηκαν τα στοιχεία επιβράβευσης.',
    referralCodeLabel: 'Κωδικός σύστασης',
    successfulReferralsLabel: 'Επιτυχείς συστάσεις',
    inviteEmailDialogTitle: 'Αποστολή συνδέσμου σύστασης',
    notificationCategoryTitle: 'Επιβράβευση',
    notificationCategoryHint: 'Κέρδος credit όταν κάποιος που προσκαλέσατε πληρώσει συνδρομή',
    settingsAccountTabHint: 'Επιβράβευση, ειδοποιήσεις',
};
